/**
 * Reistijd-slider — Lokale Privacy-Omloop.
 *
 * De 4-cijferige postcode van de praktijk / het thuiswerkadres wordt uitsluitend in
 * localStorage bewaard en nooit naar de Belagom-server gestuurd. Het postcodebestand
 * (PC4 → centroïde) zit in de frontend-bundle, dus de hemelsbrede afstand tot de
 * leslocatie wordt 100% lokaal berekend.
 */
import postcode4 from '../data/postcode4.json';

const PC4 = postcode4 as unknown as Record<string, [number, number]>;

export const PRO_POSTCODE_KEY = 'belagom.proAcademy.postcode4';

/** Slider-stappen (km); null = Heel Nederland. */
export const AFSTAND_STAPPEN: Array<number | null> = [5, 10, 15, 25, 50, 75, 100, null];

export function normaliseerPostcode4(input: string | null | undefined): string | null {
  const cijfers = (input ?? '').replace(/\D/g, '').slice(0, 4);
  return /^[1-9]\d{3}$/.test(cijfers) && PC4[cijfers] ? cijfers : null;
}

export function leesEigenPostcode(): string | null {
  try {
    return normaliseerPostcode4(window.localStorage.getItem(PRO_POSTCODE_KEY));
  } catch {
    return null;
  }
}

export function bewaarEigenPostcode(pc4: string | null): void {
  try {
    if (pc4) window.localStorage.setItem(PRO_POSTCODE_KEY, pc4);
    else window.localStorage.removeItem(PRO_POSTCODE_KEY);
  } catch {
    /* privémodus of opslag geblokkeerd: dan alleen voor deze pagina-sessie */
  }
}

/** Hemelsbrede afstand (km) tussen twee PC4-centroïden; null als een postcode onbekend is. */
export function afstandKm(vanPc4: string | null | undefined, naarPc4: string | null | undefined): number | null {
  const a = vanPc4 ? PC4[vanPc4] : undefined;
  const b = naarPc4 ? PC4[naarPc4] : undefined;
  if (!a || !b) return null;
  const R = 6371;
  const rad = (d: number) => (d * Math.PI) / 180;
  const dLat = rad(b[0] - a[0]);
  const dLon = rad(b[1] - a[1]);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLon / 2) ** 2;
  return Math.round(2 * R * Math.asin(Math.sqrt(h)) * 10) / 10;
}
